const TokenKey = 'Jushi-Token'

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token, expire = 3600) {
  localStorage.setItem(TokenKey, token);
  localStorage.setItem('token_now', new Date().getTime());
  localStorage.setItem('token_expire', expire * 1000);
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function getAuth() {
  var token = localStorage.getItem(TokenKey)
  if (token) {
    return true;
  } else {
    return false;
  }
}
export function checkAuth() {
  var now = new Date().getTime();
  var oldTime = localStorage.getItem('token_now');
  var expire = localStorage.getItem('token_expire');
  return getAuth() && (now - oldTime < expire);
}



// WEBPACK FOOTER //
// ./src/util/auth.js